import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const platformCondition = !IS_MOBILE_BROWSER && !IS_WEBVIEW;

export const trialExpiryReminder: boolean = platformCondition && (isFeature('trial-expiry-reminder') || false);

if (platformCondition) {
    registerExperiment(
        'trial-expr-rmdr',
        trialExpiryReminder,
        [
            AnalyticEventNames.MY_TARIFF_OPEN,
            AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY,
            AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_SAVE,
            AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_TRUE,

            AnalyticEventNames.CANCEL_SUB_EMPTY_FAMILY,
            AnalyticEventNames.CANCEL_SUB_EMPTY_FAMILY_CLICK,
            AnalyticEventNames.CANCEL_SUB_FAMILY,
            AnalyticEventNames.CANCEL_SUB_FAMILY_CLICK,
            AnalyticEventNames.CANCEL_SUB_FAMILY_CANCEL,
        ],
        {
            sendXrayArgs: {
                MY_TARIFF_OPEN: ({ isTrial }) => ({ eventName: `open-tariff-${isTrial ? 't' : 'nt'}` }),
                MY_TARIFF_CANCEL_AUTOPAY: ({ isTrial }) => ({ eventName: `cancel-autopay-${isTrial ? 't' : 'nt'}` }),
                MY_TARIFF_CANCEL_AUTOPAY_SAVE: ({ isTrial }) => ({ eventName: `cancel-save-${isTrial ? 't' : 'nt'}` }),
                MY_TARIFF_CANCEL_AUTOPAY_TRUE: ({ isTrial }) => ({ eventName: `cancel-true-${isTrial ? 't' : 'nt'}` }),
            },

            mapEventNames: {
                CANCEL_SUB_EMPTY_FAMILY: 'show-fam-empty',
                CANCEL_SUB_EMPTY_FAMILY_CLICK: 'fam-add',
                CANCEL_SUB_FAMILY: 'show-fam',
                CANCEL_SUB_FAMILY_CLICK: 'fam-save',
                CANCEL_SUB_FAMILY_CANCEL: 'fam-cancel',
            },
        }
    );
}
